import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Provider} from "react-redux";
import store from "./store/store";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import SignIn from "./pages/loginPage";
import './i18n';
import WorkerAdd from "./pages/workerAdd";
import Workers from "./pages/workers";
import EditWorker from "./pages/editWorker";
import Documents from "./pages/documents";
import Stats from "./pages/stats";
import AddStat from "./pages/addStat";
import EditStat from "./pages/editStat";
import ViewStat from "./pages/viewStat";
import EditDocument from "./pages/editDocument";
import DocumentAdd from "./pages/documentAdd";
import AddEvents from "./pages/addEvents";
import Events from "./pages/events";
import ViewEvent from "./pages/viewEvent";
import EditEvent from "./pages/editEvent";
import Members from "./pages/members";
import EditMember from "./pages/editMember";
import AddMember from "./pages/addMember";
import Main from "./pages/main";
import Regions from "./pages/regions";
import Districts from "./pages/districts";
import MyDistricts from "./pages/myDistricts";
import DistrictCabinet from "./pages/districtCabinet";
import MyDepartment from "./pages/myDepartment";
import Problems from "./pages/problems";
import ProblemAdd from "./pages/problemAdd";
import EditProblem from "./pages/editProblem";
import ViewProblem from "./pages/viewProblem";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Suspense fallback={'Loading...'}>
            <Provider store={store}>
                <Routes>
                    <Route path={'/'} element={<App/>}/>
                    <Route path={'/dashboard/'} element={<App/>}/>
                    <Route path={'/login/'} element={<SignIn/>}/>
                    <Route path={'/documents/'} element={<Documents/>}/>
                    <Route path={'/documents/:id'} element={<Documents/>}/>
                    <Route path={'/problems/'} element={<Problems/>}/>
                    <Route path={'/problems/:id'} element={<Problems/>}/>
                    <Route path={'/add-problem/'} element={<ProblemAdd/>}/>
                    <Route path={'/edit-problem/:id'} element={<EditProblem/>}/>
                    <Route path={'/view-problem/:id'} element={<ViewProblem/>}/>
                    <Route path={'/add-document/'} element={<DocumentAdd/>}/>
                    <Route path={'/edit-document/:id'} element={<EditDocument/>}/>
                    <Route path={'/workers/'} element={<Workers/>}/>
                    <Route path={'/workers/:id'} element={<Workers/>}/>
                    <Route path={'/main/'} element={<Main/>}/>
                    <Route path={'/regions/'} element={<Regions/>}/>
                    <Route path={'/regions/:id'} element={<Main/>}/>
                    <Route path={'/districts/'} element={<Districts/>}/>
                    <Route path={'/region-districts/:regionId'} element={<Districts/>}/>
                    <Route path={'/my-districts/'} element={<MyDistricts/>}/>
                    <Route path={'/district-cabinet/:id'} element={<DistrictCabinet/>}/>
                    <Route path={'/my-department/'} element={<MyDepartment/>}/>
                    <Route path={'/members/'} element={<Members/>}/>
                    <Route path={'/stats/'} element={<Stats/>}/>
                    <Route path={'/members/:id'} element={<Members/>}/>
                    <Route path={'/stats/:id'} element={<Stats/>}/>
                    <Route path={'/add-stats/'} element={<AddStat/>}/>
                    <Route path={'/edit-stats/:id'} element={<EditStat/>}/>
                    <Route path={'/view-stats/:id'} element={<ViewStat/>}/>
                    <Route path={'/events/'} element={<Events/>}/>
                    <Route path={'/events/:id'} element={<Events/>}/>
                    <Route path={'/add-events/'} element={<AddEvents/>}/>
                    <Route path={'/edit-events/:id'} element={<EditEvent/>}/>
                    <Route path={'/view-events/:id'} element={<ViewEvent/>}/>
                    <Route path={'/add-worker/'} element={<WorkerAdd/>}/>
                    <Route path={'/edit-worker/:id'} element={<EditWorker/>}/>
                    <Route path={'/add-member/'} element={<AddMember/>}/>
                    <Route path={'/edit-member/:id'} element={<EditMember/>}/>
                </Routes>
            </Provider>
        </Suspense>
    </BrowserRouter>
);
